import FlagCondition from 'components/common/flag-condition/FlagCondition';
import CoursePicker from 'components/common/course-picker/CoursePicker';
import { FeatureFlagNames } from 'constants/app.constant';
import CWCourseContext from 'reports/cw/components/common/cw-course-context/CWCourseContext';
var CWCoursePickerButton = function (_a) {
    var courseSectionInfo = _a.courseSectionInfo;
    return (<FlagCondition featureFlagName={FeatureFlagNames.CW_UPDATED_UI_ENABLED} trueStatement={<CWCourseContext currentCourseName={courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.courseName}/>} falseStatement={<CoursePicker pendoClass="cw-take-tour-button" currentCourseName={courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.courseName}/>}/>);
};
export default CWCoursePickerButton;
